module.exports = __webpack_public_path__ + "static/img/3.34a880f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/3.png
// module id = ismn
// module chunks = 0